import dynamic from 'next/dynamic'

const noSSR = (importFn) => {
  const Component = dynamic(importFn, { ssr: false })

  // eslint-disable-next-line react/jsx-props-no-spreading
  return (props) => <Component {...props} />
}

export default noSSR
